/**
 * @description模块控制函数
 * @param roleName 用户角色 案件管理员/调解员/代理人
 * @param status 案件状态 1待分 40待提交  5调解中 6已达成方案 7已签署协议 3未触达  9调解失败 50已提交 8已申请司法确认 3已分案 8已申请确认 50已提交 60审核未通过，70审核通过
 * @param auditDto 审核信息 10 审核通过  1材料不完整 审核不通过
 * @param finishFlag 是否办结
 * @param archiveFlag 是否归档
 * @param judicialStatus 司法确认/提起诉讼
 */
export default function componentController(roleName, status, auditDto, finishFlag = false, archiveFlag = false, judicialStatus) {
  // 参数格式
  status = String(status)
  finishFlag = Boolean(finishFlag)
  archiveFlag = Boolean(archiveFlag)
  judicialStatus = String(judicialStatus || '1')
  auditDto = auditDto ? auditDto.status: ''
  /**
   CASE_ADMIN("case_admin", "案件管理员"),
   MEDIATOR("mediator", "调解员"),
   AGENT("agent", "代理人"),
   ORG_ADMIN("org_admin", "机构管理员"),
   OPERATION("operation", "运营"),
   **/

  const M_O_CONFIG = {
    // 全局状态
    isEdit: false,
    // 审核信息
    auditInfo: {
      isShow: true,
      isEdit: false,
    },
    // 预设方案
    preRepaymentPlan: {
      isShow: true,
      isEdit: false,
    },
    // 基础信息
    baseInfo: {
      isShow: true,
      isEdit: false,
      // 案件分类
      caseType: {
        isEdit: false
      }
    },
    // 请求信息
    queryInfo:{
      isShow: true,
      isEdit: false,
    },
    // 申请人信息
    applicantInfo: {
      isShow: true,
      isEdit: false
    },
    // 被申请人信息
    respondentInfo: {
      isShow: true,
      isEdit: false
    },
    // 要素信息
    debtInfo: {
      isShow: true,
      isEdit: false
    },
    // 沟通记录
    contactDetail: {
      isShow: false,
      isEdit: false,
    },
    // 还款方案
    repaymentSchemeRegistration: {
      isShow: false,
      isEdit: false
    },
    // 还款计划
    labelRespondent: {
      isShow: false,
      isEdit: false
    },
    // 还款记录
    recentPayment: {
      isShow: false,
      isEdit: false
    },
    // 缴费信息
    paymentInformation: {
      isShow: false,
      isEdit: false
    },
    // 诉讼/司法确认信息
    litigationJusticeInformation: {
      isShow: true,
      isEdit: false
    },
    // 文件
    file: {
      // 总的上传
      canUpload: false,
      // 起诉状
      indictment: false,
    },
  }
  const I_K_CONFIG = {
    // 全局状态
    isEdit: false,
    // 审核信息
    auditInfo: {
      isShow: true,
      isEdit: false,
    },
    // 预设方案
    preRepaymentPlan: {
      isShow: true,
      isEdit: false,
    },
    // 基础信息
    baseInfo: {
      isShow: true,
      isEdit: false,
      // 案件分类
      caseType: {
        isEdit: false
      }
    },
    // 请求信息
    queryInfo:{
      isShow: true,
      isEdit: false,
    },
    // 申请人信息
    applicantInfo: {
      isShow: true,
      isEdit: false
    },
    // 被申请人信息
    respondentInfo: {
      isShow: true,
      isEdit: false
    },
    // 要素信息
    debtInfo: {
      isShow: true,
      isEdit: false
    },
    // 沟通记录
    contactDetail: {
      isShow: false,
      isEdit: false,
    },
    // 还款方案
    repaymentSchemeRegistration: {
      isShow: false,
      isEdit: false
    },
    // 还款计划
    labelRespondent: {
      isShow: false,
      isEdit: false
    },
    // 还款记录
    recentPayment: {
      isShow: false,
      isEdit: false
    },
    // 缴费信息
    paymentInformation: {
      isShow: false,
      isEdit: false
    },
    // 诉讼/司法确认信息
    litigationJusticeInformation: {
      isShow: false,
      isEdit: false
    },
    // 文件
    file: {
      // 总的上传
      canUpload: false,
      // 起诉状
      indictment: false,
    },
  }
  let agent = {
    // 代理人 - 待提交 status[40]
    C: {
      // 全局状态
      isEdit: true,
      // 审核信息
      auditInfo: {
        isShow: false,
        isEdit: false,
      },
      // 预设方案
      preRepaymentPlan: {
        isShow: true,
        isEdit: true,
      },
      // 基础信息
      baseInfo: {
        isShow: true,
        isEdit: true,
        // 案件分类
        caseType: {
          isEdit: true
        }
      },
      // 请求信息
      queryInfo:{
        isShow: true,
        isEdit: true,
      },
      // 申请人信息
      applicantInfo: {
        isShow: true,
        isEdit: true
      },
      // 被申请人信息
      respondentInfo: {
        isShow: true,
        isEdit: true
      },
      // 要素信息
      debtInfo: {
        isShow: true,
        isEdit: true
      },
      // 沟通记录
      contactDetail: {
        isShow: false,
        isEdit: false,
      },
      // 还款方案
      repaymentSchemeRegistration: {
        isShow: false,
        isEdit: false
      },
      // 还款计划
      labelRespondent: {
        isShow: false,
        isEdit: false
      },
      // 还款记录
      recentPayment: {
        isShow: false,
        isEdit: false
      },
      // 缴费信息
      paymentInformation: {
        isShow: false,
        isEdit: false
      },
      // 诉讼/司法确认信息
      litigationJusticeInformation: {
        isShow: false,
        isEdit: false
      },
      // 文件
      file: {
        // 总的上传
        canUpload: true,
        // 起诉状
        indictment: true,
      },
    },
    // 代理人 - 已提交 status[50]
    E: {
      // 全局状态
      isEdit: false,
      // 审核信息
      auditInfo: {
        isShow: false,
        isEdit: false,
      },
      // 预设方案
      preRepaymentPlan: {
        isShow: true,
        isEdit: false,
      },
      // 基础信息
      baseInfo: {
        isShow: true,
        isEdit: false,
        // 案件分类
        caseType: {
          isEdit: false
        }
      },
      // 请求信息
      queryInfo:{
        isShow: true,
        isEdit: false,
      },
      // 申请人信息
      applicantInfo: {
        isShow: true,
        isEdit: false
      },
      // 被申请人信息
      respondentInfo: {
        isShow: true,
        isEdit: false
      },
      // 要素信息
      debtInfo: {
        isShow: true,
        isEdit: false
      },
      // 沟通记录
      contactDetail: {
        isShow: false,
        isEdit: false,
      },
      // 还款方案
      repaymentSchemeRegistration: {
        isShow: false,
        isEdit: false
      },
      // 还款计划
      labelRespondent: {
        isShow: false,
        isEdit: false
      },
      // 还款记录
      recentPayment: {
        isShow: false,
        isEdit: false
      },
      // 缴费信息
      paymentInformation: {
        isShow: false,
        isEdit: false
      },
      // 诉讼/司法确认信息
      litigationJusticeInformation: {
        isShow: false,
        isEdit: false
      },
      // 文件
      file: {
        // 总的上传
        canUpload: false,
        // 起诉状
        indictment: false,
      },
    },
    // 代理人 - 审核不通过且材料不完整 status[60] && auditDto[1]
    G: {
      // 全局状态
      isEdit: true,
      // 审核信息
      auditInfo: {
        isShow: true,
        isEdit: false,
      },
      // 预设方案
      preRepaymentPlan: {
        isShow: true,
        isEdit: true,
      },
      // 基础信息
      baseInfo: {
        isShow: true,
        isEdit: false,
        // 案件分类
        caseType: {
          isEdit: false
        }
      },
      // 请求信息
      queryInfo:{
        isShow: true,
        isEdit: true,
      },
      // 申请人信息
      applicantInfo: {
        isShow: true,
        isEdit: true
      },
      // 被申请人信息
      respondentInfo: {
        isShow: true,
        isEdit: true
      },
      // 要素信息
      debtInfo: {
        isShow: true,
        isEdit: true
      },
      // 沟通记录
      contactDetail: {
        isShow: false,
        isEdit: false,
      },
      // 还款方案
      repaymentSchemeRegistration: {
        isShow: false,
        isEdit: false
      },
      // 还款计划
      labelRespondent: {
        isShow: false,
        isEdit: false
      },
      // 还款记录
      recentPayment: {
        isShow: false,
        isEdit: false
      },
      // 缴费信息
      paymentInformation: {
        isShow: false,
        isEdit: false
      },
      // 诉讼/司法确认信息
      litigationJusticeInformation: {
        isShow: false,
        isEdit: false
      },
      // 文件
      file: {
        // 总的上传
        canUpload: true,
        // 起诉状
        indictment: true,
      },
    },
    // 代理人 - 审核不通过/审核通过/调解中/已签署协议/调解失败 status[60, 70, 5, 7, 9]
    I: I_K_CONFIG,
    // 代理人 - 调解成功-未发起申请 status[10] && judicialStatus[1]
    K: I_K_CONFIG,
    // 代理人 - 调解成功-已发起申请 status[10] && judicialStatus[2]
    M: M_O_CONFIG,
    // 代理人 - 调解成功-已给予确认/未予确认 status[10] && judicialStatus[3,4]
    O: M_O_CONFIG,
  }
  let case_admin = {
    // 案件管理员 -- 待审核 status[50]
    Q: {
      // 全局状态
      isEdit: true,
      // 审核信息
      auditInfo: {
        isShow: false,
        isEdit: false,
      },
      // 预设方案
      preRepaymentPlan: {
        isShow: true,
        isEdit: true,
      },
      // 基础信息
      baseInfo: {
        isShow: true,
        isEdit: true,
        // 案件分类
        caseType: {

        }
      },
      // 请求信息
      queryInfo:{
        isShow: true,
        isEdit: true,
      },
      // 申请人信息
      applicantInfo: {
        isShow: true,
        isEdit: true
      },
      // 被申请人信息
      respondentInfo: {
        isShow: true,
        isEdit: true
      },
      // 要素信息
      debtInfo: {
        isShow: true,
        isEdit: true
      },
      // 沟通记录
      contactDetail: {
        isShow: false,
        isEdit: false,
      },
      // 还款方案
      repaymentSchemeRegistration: {
        isShow: false,
        isEdit: false
      },
      // 还款计划
      labelRespondent: {
        isShow: false,
        isEdit: false
      },
      // 还款记录
      recentPayment: {
        isShow: false,
        isEdit: false
      },
      // 缴费信息
      paymentInformation: {
        isShow: false,
        isEdit: false
      },
      // 诉讼/司法确认信息
      litigationJusticeInformation: {
        isShow: false,
        isEdit: false
      },
      // 文件
      file: {
        // 总的上传
        canUpload: true,
        // 起诉状
        indictment: true,
      },
    },
    // 案件管理员 -- 审核不通过 status[60]
    S: {
      // 全局状态
      isEdit: false,
      // 审核信息
      auditInfo: {
        isShow: true,
        isEdit: false,
      },
      // 预设方案
      preRepaymentPlan: {
        isShow: true,
        isEdit: false,
      },
      // 基础信息
      baseInfo: {
        isShow: true,
        isEdit: false,
        // 案件分类
        caseType: {
          isEdit: false
        }
      },
      // 请求信息
      queryInfo:{
        isShow: true,
        isEdit: false,
      },
      // 申请人信息
      applicantInfo: {
        isShow: true,
        isEdit: false
      },
      // 被申请人信息
      respondentInfo: {
        isShow: true,
        isEdit: false
      },
      // 要素信息
      debtInfo: {
        isShow: true,
        isEdit: false
      },
      // 沟通记录
      contactDetail: {
        isShow: false,
        isEdit: false,
      },
      // 还款方案
      repaymentSchemeRegistration: {
        isShow: false,
        isEdit: false
      },
      // 还款计划
      labelRespondent: {
        isShow: false,
        isEdit: false
      },
      // 还款记录
      recentPayment: {
        isShow: false,
        isEdit: false
      },
      // 缴费信息
      paymentInformation: {
        isShow: false,
        isEdit: false
      },
      // 诉讼/司法确认信息
      litigationJusticeInformation: {
        isShow: false,
        isEdit: false
      },
      // 文件
      file: {
        // 总的上传
        canUpload: false,
        // 起诉状
        indictment: false,
      },
    },
    // 案件管理员 -- 待分案 status[1]
    U: {
      // 全局状态
      isEdit: true,
      // 审核信息
      auditInfo: {
        isShow: true,
        isEdit: false,
      },
      // 预设方案
      preRepaymentPlan: {
        isShow: true,
        isEdit: false,
      },
      // 基础信息
      baseInfo: {
        isShow: true,
        isEdit: true,
        // 案件分类
        caseType: {
          isEdit: false
        }
      },
      // 请求信息
      queryInfo:{
        isShow: true,
        isEdit: true,
      },
      // 申请人信息
      applicantInfo: {
        isShow: true,
        isEdit: true
      },
      // 被申请人信息
      respondentInfo: {
        isShow: true,
        isEdit: true
      },
      // 要素信息
      debtInfo: {
        isShow: true,
        isEdit: true
      },
      // 沟通记录
      contactDetail: {
        isShow: false,
        isEdit: false,
      },
      // 还款方案
      repaymentSchemeRegistration: {
        isShow: false,
        isEdit: false
      },
      // 还款计划
      labelRespondent: {
        isShow: false,
        isEdit: false
      },
      // 还款记录
      recentPayment: {
        isShow: false,
        isEdit: false
      },
      // 缴费信息
      paymentInformation: {
        isShow: false,
        isEdit: false
      },
      // 诉讼/司法确认信息
      litigationJusticeInformation: {
        isShow: false,
        isEdit: false
      },
      // 文件
      file: {
        // 总的上传
        canUpload: true,
        // 起诉状
        indictment: true,
      },
    },
    // 案件管理员 -- 已分案 status[3]
    W: {
      // 全局状态
      isEdit: false,
      // 审核信息
      auditInfo: {
        isShow: true,
        isEdit: false,
      },
      // 预设方案
      preRepaymentPlan: {
        isShow: true,
        isEdit: false,
      },
      // 基础信息
      baseInfo: {
        isShow: true,
        isEdit: false,
        // 案件分类
        caseType: {
          isEdit: false
        }
      },
      // 请求信息
      queryInfo:{
        isShow: true,
        isEdit: false,
      },
      // 申请人信息
      applicantInfo: {
        isShow: true,
        isEdit: false
      },
      // 被申请人信息
      respondentInfo: {
        isShow: true,
        isEdit: false
      },
      // 要素信息
      debtInfo: {
        isShow: true,
        isEdit: false
      },
      // 沟通记录
      contactDetail: {
        isShow: true,
        isEdit: false,
      },
      // 还款方案
      repaymentSchemeRegistration: {
        isShow: false,
        isEdit: false
      },
      // 还款计划
      labelRespondent: {
        isShow: false,
        isEdit: false
      },
      // 还款记录
      recentPayment: {
        isShow: false,
        isEdit: false
      },
      // 缴费信息
      paymentInformation: {
        isShow: false,
        isEdit: false
      },
      // 诉讼/司法确认信息
      litigationJusticeInformation: {
        isShow: false,
        isEdit: false
      },
      // 文件
      file: {
        // 总的上传
        canUpload: false,
        // 起诉状
        indictment: false,
      },
    },
    // 案件管理员 -- 已结案/已归档 finishFlag[true] || archiveFlag[true]
    Y: {
      // 全局状态
      isEdit: false,
      // 审核信息
      auditInfo: {
        isShow: false,
        isEdit: false,
      },
      // 预设方案
      preRepaymentPlan: {
        isShow: true,
        isEdit: false,
      },
      // 基础信息
      baseInfo: {
        isShow: true,
        isEdit: false,
        // 案件分类
        caseType: {
          isEdit: false
        }
      },
      // 请求信息
      queryInfo:{
        isShow: true,
        isEdit: false,
      },
      // 申请人信息
      applicantInfo: {
        isShow: true,
        isEdit: false
      },
      // 被申请人信息
      respondentInfo: {
        isShow: true,
        isEdit: false
      },
      // 要素信息
      debtInfo: {
        isShow: true,
        isEdit: false
      },
      // 沟通记录
      contactDetail: {
        isShow: true,
        isEdit: false,
      },
      // 还款方案
      repaymentSchemeRegistration: {
        isShow: true,
        isEdit: false
      },
      // 还款计划
      labelRespondent: {
        isShow: true,
        isEdit: false
      },
      // 还款记录
      recentPayment: {
        isShow: true,
        isEdit: false
      },
      // 缴费信息
      paymentInformation: {
        isShow: true,
        isEdit: false
      },
      // 诉讼/司法确认信息
      litigationJusticeInformation: {
        isShow: true,
        isEdit: false
      },
      // 文件
      file: {
        // 总的上传
        canUpload: false,
        // 起诉状
        indictment: false,
      },
    },
  }
  // 目前 AC/AE/AG/AI配置相同，提取出来
  const AC_AE_AG_AI_CONFIG = {
    // 全局状态
    isEdit: false,
    // 审核信息
    auditInfo: {
      isShow: false,
      isEdit: false,
    },
    // 预设方案
    preRepaymentPlan: {
      isShow: true,
      isEdit: false,
    },
    // 基础信息
    baseInfo: {
      isShow: true,
      isEdit: false,
      // 案件分类
      caseType: {
        isEdit: false
      }
    },
    // 请求信息
    queryInfo:{
      isShow: true,
      isEdit: false,
    },
    // 申请人信息
    applicantInfo: {
      isShow: true,
      isEdit: false
    },
    // 被申请人信息
    respondentInfo: {
      isShow: true,
      isEdit: false
    },
    // 要素信息
    debtInfo: {
      isShow: true,
      isEdit: false
    },
    // 沟通记录
    contactDetail: {
      isShow: true,
      isEdit: false,
    },
    // 还款方案
    repaymentSchemeRegistration: {
      isShow: true,
      isEdit: false
    },
    // 还款计划
    labelRespondent: {
      isShow: true,
      isEdit: false
    },
    // 还款记录
    recentPayment: {
      isShow: true,
      isEdit: false
    },
    // 缴费信息
    paymentInformation: {
      isShow: true,
      isEdit: false
    },
    // 诉讼/司法确认信息
    litigationJusticeInformation: {
      isShow: true,
      isEdit: false
    },
    // 文件
    file: {
      // 总的上传
      canUpload: false,
      // 起诉状
      indictment: false,
    },
  }
  let mediator = {
    // 调解员 - 未触达/调解中/达成方案/签署协议/调解失败
    // status[3, 5, 6, 7, 9]
    AA: {
      // 全局状态
      isEdit: true,
      // 审核信息
      auditInfo: {
        isShow: false,
        isEdit: false,
      },
      // 预设方案
      preRepaymentPlan: {
        isShow: true,
        isEdit: false,
      },
      // 基础信息
      baseInfo: {
        isShow: true,
        isEdit: true,
        // 案件分类
        caseType: {
          isEdit: false
        }
      },
      // 请求信息
      queryInfo:{
        isShow: true,
        isEdit: true,
      },
      // 申请人信息
      applicantInfo: {
        isShow: true,
        isEdit: true
      },
      // 被申请人信息
      respondentInfo: {
        isShow: true,
        isEdit: true
      },
      // 要素信息
      debtInfo: {
        isShow: true,
        isEdit: true
      },
      // 沟通记录
      contactDetail: {
        isShow: true,
        isEdit: true,
      },
      // 还款方案
      repaymentSchemeRegistration: {
        isShow: true,
        isEdit: true
      },
      // 还款计划
      labelRespondent: {
        isShow: true,
        isEdit: true
      },
      // 还款记录
      recentPayment: {
        isShow: true,
        isEdit: true,
        // 登记人
        stageRegistUserName: {
          isEdit: false,
        },
        // 登记时间
        stageRegistTime: {
          isEdit: false,
        },
      },
      // 缴费信息
      paymentInformation: {
        isShow: true,
        isEdit: false
      },
      // 诉讼/司法确认信息
      litigationJusticeInformation: {
        isShow: false,
        isEdit: false
      },
      // 文件
      file: {
        // 总的上传
        canUpload: true,
        // 起诉状
        indictment: true,
      },
    },
    // 调解员 - 办结-调解成功-未发起申请/办结-调解失败-未提起诉讼
    // finishFlag[true] && ( status[10] && judicialStatus[1] || status[9] && judicialStatus[1] )
    AC: AC_AE_AG_AI_CONFIG,
    // 调解员 - 办结-调解成功-已发起申请/办结-调解失败-已提起诉讼
    // finishFlag[true] && ( status[10] && judicialStatus[2] || status[9] && judicialStatus[2] )
    AE: AC_AE_AG_AI_CONFIG,
    // 调解员 - 办结-调解失败-已结案/办结-调解成功-已给予确认/办结-调解成功-未予确认
    // finishFlag[true] && ( status[9] && judicialStatus[3] || status[10] && judicialStatus[3,4] )
    AG: AC_AE_AG_AI_CONFIG,
    // 调解员 - 归档案件 archiveFlag[true]
    AI: AC_AE_AG_AI_CONFIG,
  }
  let controller = {}
  let key = ''
  switch (roleName) {
    case '代理人':
      if(status === '40'){
        key = 'C'
      }
      if(status === '50'){
        key = 'E'
      }

      if(['60','70','5','6','7','9', '1', '3'].includes(status)){
        key = 'I'
      }
      if(status === '60' && auditDto === '1'){
        key = 'G'
      }

      if(status === '10' && judicialStatus === '1'){
        key = 'K'
      }
      if(status === '10' && judicialStatus === '2'){
        key = 'M'
      }
      if(status === '10' && ['3', '4'].includes(judicialStatus)){
        key = 'O'
      }
      controller = agent[key]
      break
    case '案件管理员':
      if(status === '50'){
        key = 'Q'
      }
      if(status === '60'){
        key = 'S'
      }
      if(status === '1'){
        key = 'U'
      }
      if(['3','5','6','7','9'].includes(status)){
        key = 'W'
      }
      if(finishFlag || archiveFlag){
        key = 'Y'
      }
      controller = case_admin[key]
      break
    case '调解员':
      if(['3','5','6','7','9'].includes(status)){
        key = 'AA'
      }
      if(finishFlag && ( status === '10' && judicialStatus === '1' || status === '9' && judicialStatus === '1')){
        key = 'AC'
      }
      if(finishFlag && ( status === '10' && judicialStatus === '2' || status === '9' && judicialStatus === '2')){
        key = 'AE'
      }
      if(finishFlag && ( status === '9' && judicialStatus === '3' || status === '10' && ['3', '4'].includes(judicialStatus))){
        key = 'AG'
      }
      if(archiveFlag){
        key = 'AI'
      }
      controller = mediator[key]
      break
  }
  return controller
}
